/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Active inactive entity dialog component
  Date: June 15, 2020
**/

import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';
import {
  Grid,
  TextField,
  DialogContent,
  Dialog,
  makeStyles,
  Button,
  Box,
  Typography,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import styles from './dialogActiveInactiveEntity.module.scss';
import { globalDateEntity, DatepickerStartDate } from '../../constants/applicationConstants';
import { stringConstants } from '../../constants/stringConstants';
import { replaceDateFormat } from '../../utils/common';
/** STYLES HERE * */
const useStyles = makeStyles((theme) => ({
  dateFieldWidth: {
    width: '100%',
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
  },
}));
const DialogActiveInactiveEntityContainer = (props) => {
  const classes = useStyles();

  const {
    heading,
    dialogType,
    onClose,
    dateField,
    higherEffectiveDate,
    open,
    ...other
  } = props;

  const [reason, setReason] = React.useState(''); // SET REASON VALUE
  const [reasonValidation, setReasonValidation] = React.useState(''); // REASON CHAR LIMIT VALIDATION
  const [inactiveDate, setInactiveDate] = React.useState(new Date()); // SET EFFECTIVE DATE VALUE
  const [inactiveDateValidation, setInactiveDateValidation] = React.useState(
    '',
  );

  // reset if older values fields while opening the dialog box
  const handleEntering = () => {
    try {
      setInactiveDate(new Date());
    } catch (err) {
      //
    }
  };
  /** DAILOG POPUP CANCEL AND OKAY * */
  const handleOkCancel = (val) => {
    try {
      if (val === 'okay') {
        if (!inactiveDate) {
          setInactiveDateValidation(stringConstants.requiredValidationMsg);
          return false;
        }
        if (higherEffectiveDate && higherEffectiveDate != "") {
          let higherEffectiveDateVal = replaceDateFormat(higherEffectiveDate);
          const oldEffectiveDate1 = new Date(higherEffectiveDateVal);

          if (Date.parse(oldEffectiveDate1) > Date.parse(inactiveDate)) {
            setInactiveDateValidation(
              stringConstants.deactiveEnityDatePriorValidationMsg,
            );
            return false;
          }
        }

        if (reason == '') {
          setReasonValidation(stringConstants.requiredValidationMsg);
          return false;
        }
        if (reason.length > 256) {
          setReasonValidation(stringConstants.reasonLimitValidationMsg);
          return false;
        }
        onClose({
          inactiveDate,
          reason,
        });
      } else {
        onClose(null);
      }
      /** SET DEFAULD ALL FIELDS SETTERS * */
      setInactiveDate(new Date());
      setInactiveDateValidation('');
      setReasonValidation('');
      setReason('');
    } catch (err) {
      //
    }
  };

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="sm"
      onEntering={handleEntering}
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
      PaperProps={{
        style: { borderRadius: 20 }
      }}
    >
      <Box className={styles.dialogmainwrapper}>
        <DialogContent>
          <Grid container spacing={2} className={`addNewForm`}>
            <Grid item md={12} xs={12}>
              <Typography variant="h6" component="h6">{heading}</Typography>
            </Grid>
            {dialogType === 'deactivate' && (
              <Grid item md={12} xs={12} className={`positionRelative`}>
                <KeyboardDatePicker
                  label={dateField}
                  format={globalDateEntity.datePickerFormat}
                  className={classes.dateFieldWidth}
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  required
                  id="inactiveDate"
                  name="inactiveDate"
                  value={inactiveDate ? inactiveDate : null}
                  onChange={(e, value) => {
                    setInactiveDate(e ? e : '');
                    setInactiveDateValidation('');
                    if (moment(e).isValid() == false) {
                      setInactiveDateValidation(stringConstants.invalidDate);
                    }
                    if (Date.parse(moment(e).format()) < Date.parse(DatepickerStartDate)) {
                      setInactiveDateValidation(stringConstants.minDate);
                    }
                  }}
                  minDate={new Date(DatepickerStartDate)}
                  minDateMessage={stringConstants.minDate}
                  error={inactiveDateValidation}
                  helperText={inactiveDateValidation}
                />
                <Tooltip title="Remove Date">
                  <IconButton
                    className={`closeEndDatePosition`}
                    color="primary"
                    aria-label="Remove Date"
                    onClick={() => { setInactiveDateValidation(''); setInactiveDate(null); }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
            <Grid item md={12} xs={12}>
              <TextField
                required
                className={`${styles.descriptionField}`}
                multiline
                rows="3"
                fullWidth
                id="reason"
                name="reason"
                variant="outlined"
                value={reason}
                onChange={(event) => {
                  setReason(event.target.value);
                  setReasonValidation('');
                }}
                label="Reason"
                error={reasonValidation}
                helperText={reasonValidation}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            className={styles.btns}
          >
            <Grid item>
              <Button
                onClick={() => handleOkCancel('cancel')}
                variant="contained"
                color="secondary"
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                autoFocus
                variant="contained"
                onClick={() => handleOkCancel('okay')}
                color="primary"
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Box>
    </Dialog>
  );
};
DialogActiveInactiveEntityContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
export default DialogActiveInactiveEntityContainer;
